module.exports = __webpack_public_path__ + "img/top@2x.08e31dde.jpg";